import Vue from 'vue'

export function commaFormat(value) {
  if (!value) return '0'
  const strNumber = value.toString().replace(/[^\d\\-]/g, '')
  const plainNumber = Number(strNumber).toString()
  return plainNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
Vue.filter('commaFormat', commaFormat)

export function commaRemove(value) {
  if (typeof value === 'number') {
    return value
  }
  return value.replace(/[^\d]/g, '')
}

Vue.filter('commaRemove', commaRemove)

Vue.filter('won', function (value) {
  if (!value) return '0'
  return value.toString() + '원'
})

export function rateFormat(value, digits) {
  const d = digits ?? 2
  const v = parseFloat(value) * 100
  // return v.toPrecision(d + 1) 소수점 첫 번째자리
  return v.toPrecision(d)
}

Vue.filter('rateFormat', rateFormat)
